import { Table } from "antd";
import React from "react";
import recieve from "../../../../assets/img/dashboard/receipt-text.svg";
import calandar from "../../../../assets/img/dashboard/calendar.svg";
import prcie from "../../../../assets/img/dashboard/money.svg";


const columns = [
  {
    title: "نوع تراکنش",
    dataIndex: "type",
    key: "type"
  },
  {
    title: "تاریخ تراکنش",
    dataIndex: "date",
    key: "date"
  },
  {
    title: "مبلغ تراکنش",
    dataIndex: "cost",
    key: "cost"
  },
  {
    title: "شماره پیش فاکتور",
    dataIndex: "factor",
    key: "factor"
  }
];
const WalletTable = ({walletInfo}) => {
  return (
    <div className="mt-[90px] WalletTable">
      <h3>لیست تراکنش های شما</h3>
      <div className="WalletTable--filterbox">
        <div className="WalletTable--filterbox--box">
          <img src={recieve} />
          <p>
            نوع تراکنش
            <span>( نمایش همه )</span>
          </p>{" "}
        </div>
        <div className="WalletTable--filterbox--box">
          <img src={calandar} />
          <p>
          بازه زمانی
        
            <span>   ( یک ماه اخیر )</span>
          </p>{" "}
        </div>
        <div className="WalletTable--filterbox--box">
          <img src={prcie} />
          <p>
          بازه مبلغ 
          
            <span>( از ۳/۰۰۰/۰۰۰ تومان )</span>
          </p>{" "}
        </div>
      </div>
      <div className="Primary-table">
        {/* <Table dataSource={dataSource} columns={columns} />; */}
        <div className="Primary-table--head">
          <div>نوع تراکنش </div>
          <div>تاریخ تراکنش </div>
          <div>مبلغ تراکنش </div>
          <div>وضعیت تراکنش</div>
        </div>
      { walletInfo.transactions?.map(i=>
      <div className="Primary-table--body">
      <div>{i.type}</div>
      <div>{i.date}</div>
      <div>{i.amount} ریال </div>
      <div className="font-bold">{i.status}</div>
    </div>
      ) }
      
      </div>
    </div>
  );
};

export default WalletTable;
